import DOMPurify from 'dompurify';

// Door een aanbieder zelf ingevulde HTML (nu enkel de aangepaste footer van de
// boekingspagina, Instellingen > Link & huisstijl) mag NOOIT ongefilterd op een
// pagina van onze eigen origin komen: die pagina draait op hetzelfde adres als het
// dashboard van alle andere aanbieders, dus een <img onerror=...> of
// <a href="javascript:..."> zou de sessie van elke ingelogde bezoeker kunnen
// overnemen. Daarom een vaste lijst van opmaak-tags en -attributen (precies wat de
// helptekst belooft: "HTML-tags voor opmaak en links"), enkel http(s)/mailto/tel-links,
// geen style/class/id, geen afbeeldingen, formulieren of scripts.
const ALLOWED_TAGS = ['a', 'b', 'strong', 'i', 'em', 'u', 's', 'small', 'br', 'p', 'span', 'ul', 'ol', 'li'];
const ALLOWED_ATTR = ['href', 'title', 'target', 'rel'];
const ALLOWED_URI_REGEXP = /^(?:https?:|mailto:|tel:)/i;

// Elke link opent in een nieuw tabblad zonder verwijzer/koppeling naar de opener.
DOMPurify.addHook('afterSanitizeAttributes', (node) => {
    if (node.tagName === 'A' && node.hasAttribute('href')) {
        node.setAttribute('target', '_blank');
        node.setAttribute('rel', 'noopener noreferrer nofollow');
    }
});

export function sanitizeFooterHtml(dirty) {
    if (typeof dirty !== 'string' || !dirty) return '';
    return DOMPurify.sanitize(dirty, {
        ALLOWED_TAGS,
        ALLOWED_ATTR,
        ALLOWED_URI_REGEXP,
        ALLOW_DATA_ATTR: false,
        ALLOW_ARIA_ATTR: false
    });
}
